import { render } from "./BaseTable.vue?vue&type=template&id=a5b65884&scoped=true"
import script from "./BaseTable.vue?vue&type=script&lang=js"
export * from "./BaseTable.vue?vue&type=script&lang=js"

import "./BaseTable.vue?vue&type=style&index=0&id=a5b65884&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a5b65884"

export default script